import { type FlowVersionTarget } from 'flow-schema';

import { useSelectedNodeField } from '../../../ConfigFields/useSelectedNodeField.ts';

interface UseSharedSubflowBlockFieldsProps {
  fieldNamePrefix: string;
}

export function useSharedSubflowBlockFields(props: UseSharedSubflowBlockFieldsProps) {
  const { fieldNamePrefix } = props;
  const flowIdFieldProps = useSelectedNodeField<string | undefined>(`${fieldNamePrefix}.flowId`);
  const specificVersionFlowDefinitionIdFieldProps = useSelectedNodeField<string | undefined>(
    `${fieldNamePrefix}.flowDefinitionId`
  );
  const versionTargetFieldProps = useSelectedNodeField<FlowVersionTarget>(
    `${fieldNamePrefix}.versionTarget`
  );

  return {
    flowIdFieldProps,
    specificVersionFlowDefinitionIdFieldProps,
    versionTargetFieldProps,
  };
}
